const DEFAULT_CARE_CONTEXT = {
  subjectType: "person",
  ageGroup: "",
  careFocus: [],
  additionalSupports: [],
  trackingFocus: [],
  careSetting: [],
};

const cleanString = (value) => String(value || "").trim();

export const createEmptyCareContext = () => ({ ...DEFAULT_CARE_CONTEXT });

export const labelFromCareContextItem = (item) => {
  if (item == null) return "";
  if (typeof item === "string") return item.trim();
  if (typeof item === "object") {
    return cleanString(item.label || item.name || item.title || item.value || item.code);
  }
  return cleanString(item);
};

export const normalizeCareContextItem = (item) => {
  if (item == null) return null;
  if (typeof item === "string") {
    const label = item.trim();
    return label ? { code: "CUSTOM", label, custom: true } : null;
  }

  if (typeof item === "object") {
    const label = labelFromCareContextItem(item);
    if (!label) return null;

    return {
      code: cleanString(item.code || item.value || label).toUpperCase().replace(/\s+/g, "_"),
      label,
      ...(item.custom ? { custom: true } : {}),
    };
  }

  const label = cleanString(item);
  return label ? { code: "CUSTOM", label, custom: true } : null;
};

export const normalizeCareContextList = (items = []) => (
  Array.isArray(items)
    ? items.map(normalizeCareContextItem).filter(Boolean)
    : []
);

export const normalizeCareContext = (careContext = {}) => ({
  ...DEFAULT_CARE_CONTEXT,
  subjectType: cleanString(careContext.subjectType) || DEFAULT_CARE_CONTEXT.subjectType,
  ageGroup: cleanString(careContext.ageGroup),
  careFocus: normalizeCareContextList(careContext.careFocus),
  additionalSupports: normalizeCareContextList(careContext.additionalSupports),
  trackingFocus: normalizeCareContextList(careContext.trackingFocus),
  careSetting: normalizeCareContextList(careContext.careSetting),
});

export const careContextSummary = (items = [], fallback = "None") => {
  const labels = normalizeCareContextList(items).map((item) => item.label).filter(Boolean);
  return labels.length ? labels.join(", ") : fallback;
};
